import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getTeamUtilisationReport,
	getYearlyUtilisationReport,
} from "~/modules/reports/api/utilisationReport/utilisationReportApiDispatchers.ts";

export const utilisationReportQueries = {
	baseKey: ["utilisation-report"],
	yearlyTotal: (year: string) =>
		queryOptions({
			queryKey: [...utilisationReportQueries.baseKey, "total", year],
			queryFn: () => getYearlyUtilisationReport(year).then(getDataFromResponse),
			enabled: !!year,
		}),
	team: (year: string) =>
		queryOptions({
			queryKey: [...utilisationReportQueries.baseKey, "team", year],
			queryFn: () => getTeamUtilisationReport(year).then(getDataFromResponse),
			enabled: !!year,
		}),
};
